import { createBrowserHistory } from 'history';
import createSagaMiddleware from 'redux-saga';
import { applyMiddleware, compose, createStore } from 'redux';
import { routerMiddleware } from 'connected-react-router';
import { createLogger } from 'redux-logger';
import thunk from 'redux-thunk';

import createRootReducer from '../reducers';
import rootSaga from '../sagas/index';

export const history = createBrowserHistory();

const routeMiddleware = routerMiddleware(history);
const sagaMiddleware = createSagaMiddleware();
const middlewares = [thunk, sagaMiddleware, routeMiddleware];

const isDev = process.env.NODE_ENV === 'development';

if (isDev) {
  middlewares.push(
    createLogger({
      collapsed: true,
      duration: true,
    }),
  );
}

export default function configureStore(preloadedState) {
  const composer = (isDev && window?.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) || compose;

  const store = createStore(
    createRootReducer(history), // root reducer with router state
    preloadedState,
    composer(
      applyMiddleware(
        routerMiddleware(history), // for dispatching history actions
        ...middlewares,
      ),
    ),
  );

  sagaMiddleware.run(rootSaga);
  return store;
}
